<template>
  <div>
    <div class="page">
      <div
        v-if="getModuleConfig('form_title')"
        class="page__title"
      >
        {{ getModuleConfig("form_title") }}
      </div>
      <div v-if="getModuleConfig('form_desc')" class="page__desc">
        {{ getModuleConfig("form_desc") }}
      </div>
      <div class="page__content"
        v-if="getModuleConfig('content')"
        v-html="getModuleConfig('content')"
      ></div>
    </div>

    <div class="page__button s-space-y-4">
      <MemberButton
        v-if="getModuleConfig('button_text')"
        :button-text="getModuleConfig('button_text')"
        :button-url="getModuleConfig('button_url')"
        :type="getModuleConfig('button_action')"
      >
      </MemberButton>
    </div>
  </div>
</template>

<script>
import MemberButton from "@/components/Page/Liff/Shared/MemberButton.vue";
import { mapGetters } from "vuex";
import liff from "@line/liff";

export default {
  components: {
    MemberButton,
  },

  data() {
    return {
      page: "",
      showLoading: false,
    };
  },

  created() {
    this.page = this.$route.params.autoPage + "_page";
  },

  async mounted() {
    await this.init();
    await this.sendLiffMessage();
  },

  computed: {
    ...mapGetters("liffGeneral", ["liffId"]),
  },
  methods: {
    getModuleConfig(key) {
      return this.$store.getters["liffModule/getConfig"]('liff_page', this.page + '.' + key);
    },
    async sendLiffMessage() {
      if (this.getModuleConfig("send_messages.enable")) {
        await liff
          .sendMessages([
            {
              type: "text",
              text: this.getModuleConfig("send_messages.text"),
            },
          ])
          .then(() => {
            console.log("message sent");
          })
          .catch((err) => {
            console.log("error", err);
          });
        return;
      }
    },
    async init() {
      await liff
        .init({
          liffId: this.liffId,
        })
        .then(() => {
          if (!liff.isLoggedIn()) {
            liff.login({
              redirectUri: window.location.href,
            });
          }
        })
        .catch(() => {
          this.liffFailed();
        });
  },
  },
};
</script>
